import * as React from 'react';
import withWidth, { isWidthUp, WithWidth } from '@material-ui/core/withWidth';
import { DeepReadonly } from 'utility-types';
import { DesktopNavContainer } from '../../containers/Nav/DesktopNav';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';
import { IUserOrganization } from '@pec/aion-ui-core/interfaces/userOrganization';
import { Location } from 'history';
import { MobileNav } from './MobileNav';

export type OwnProps = {
  contentEl?: HTMLElement | null;
  title?: string;
  handleLogOut: () => void;
  userName: string | null;
  userEmail: string | null;
  userId?: string;
  sideNav?: JSX.Element;
  includeCompanySearch: boolean;
  organizationId?: string;
  location: Location;
  userOrganizations: DeepReadonly<IUserOrganization[]> | null;
  organization: DeepReadonly<IOrganization> | null;
  hasFetchedUserOrganizations: boolean;
};

export type Props = WithWidth & OwnProps;

const Nav: React.FC<Props> = ({
  contentEl,
  width,
  title,
  handleLogOut,
  userName,
  userEmail,
  userId,
  children,
  sideNav,
  includeCompanySearch,
  organizationId,
  location,
  userOrganizations,
  organization,
  hasFetchedUserOrganizations
}) =>
  isWidthUp('md', width) ? (
    <DesktopNavContainer
      contentEl={contentEl}
      includeCompanySearch={includeCompanySearch}
      handleLogOut={handleLogOut}
      userName={userName}
      userEmail={userEmail}
      userId={userId}
      sideNav={sideNav}
      organizationId={organizationId}
      location={location}
      userOrganizations={userOrganizations}
      organization={organization}
      hasFetchedUserOrganizations={hasFetchedUserOrganizations}
    >
      {children}
    </DesktopNavContainer>
  ) : (
    <MobileNav
      includeCompanySearch={includeCompanySearch}
      title={title}
      handleLogOut={handleLogOut}
      sideNav={sideNav}
      organizationId={organizationId}
      location={location}
      userOrganizations={userOrganizations}
      organization={organization}
    >
      {children}
    </MobileNav>
  );

export const NavComponent = withWidth()(Nav);
